import _construct from "@babel/runtime/helpers/esm/construct";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import StreamQueue from './StreamQueue';
import getKinesisConfig from './client';
var KINESIS_REFRESH_THRESHOLD = 600000; // 10 minutes
var PAGE_FOCUSED_EVENT = 'PAGE_FOCUSED_EVENT';
var PAGE_BLURRED_EVENT = 'PAGE_BLURRED_EVENT';
export var QuizEventsLogger = /*#__PURE__*/function () {
  function QuizEventsLogger() {
    _classCallCheck(this, QuizEventsLogger);
    for (var _len = arguments.length, streamQueues = new Array(_len), _key = 0; _key < _len; _key++) {
      streamQueues[_key] = arguments[_key];
    }
    this.streamQueues = streamQueues;
    this.eventTypeDict = Object.create(null);
    this.builtAt = Date.now();
    this.hasSentPageBlurredEventPreviously = false;
  }
  return _createClass(QuizEventsLogger, [{
    key: "needsRefresh",
    value: function needsRefresh() {
      var threshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : KINESIS_REFRESH_THRESHOLD;
      return Date.now() - this.builtAt > threshold;
    }
  }, {
    key: "queuesForEventType",
    value: function queuesForEventType(eventType) {
      var queues = this.eventTypeDict[eventType];
      if (queues !== void 0) return queues;
      queues = this.streamQueues.filter(function (queue) {
        return Object.keys(queue.config.eventTypes).includes(eventType);
      });
      if (!queues.length) {
        throw new Error("Unable to locate a valid StreamQueue for event type ".concat(eventType));
      }
      this.eventTypeDict[eventType] = queues;
      return queues;
    }
  }, {
    key: "enqueueEvent",
    value: function enqueueEvent(data) {
      var _this = this;
      var eventType = data.eventType;
      var queues = this.queuesForEventType(eventType);
      queues.forEach(function (queue) {
        // ignore unnecessary consecutive page_focused events.
        if (eventType === PAGE_FOCUSED_EVENT && !_this.hasSentPageBlurredEventPreviously) {
          return;
        }
        queue.push(eventType, data);
      });
      if (eventType === PAGE_BLURRED_EVENT) {
        this.hasSentPageBlurredEventPreviously = true;
      } else if (eventType === PAGE_FOCUSED_EVENT) {
        this.hasSentPageBlurredEventPreviously = false;
      }
    }
  }]);
}();
var loggers = {};
var loggerHandlers = {};
var getLogger = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(quizSessionId) {
    var kinesisConfigGetter,
      logger,
      handler,
      kinesisConfig,
      kinesisClient,
      streamQueues,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          kinesisConfigGetter = _args.length > 1 && _args[1] !== undefined ? _args[1] : getKinesisConfig;
          logger = loggers[quizSessionId];
          handler = loggerHandlers[quizSessionId];
          loggerHandlers[quizSessionId] = null;
          if (!(!logger || logger.needsRefresh())) {
            _context.next = 12;
            break;
          }
          _context.next = 7;
          return handler || kinesisConfigGetter(quizSessionId);
        case 7:
          kinesisConfig = _context.sent;
          kinesisClient = kinesisConfig.client; // Set up the StreamQueues for possible events
          streamQueues = kinesisConfig.streamConfigs.map(function (config) {
            return new StreamQueue({
              config: config,
              kinesis: kinesisClient,
              proxyDomain: kinesisConfig.proxyDomain
            });
          });
          logger = _construct(QuizEventsLogger, _toConsumableArray(streamQueues));
          // TODO: This appears to work in production, but fixing this eslint violation causes tests to fail.
          // We should probably figure out why.
          /* eslint-disable-next-line require-atomic-updates */
          loggers[quizSessionId] = logger;
        case 12:
          return _context.abrupt("return", logger);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getLogger(_x) {
    return _ref.apply(this, arguments);
  };
}();

// preliminary fetch kinesis credentials
// This method is called before submission, to send kinesis refreshing requests
// before scope is switched to quiz.results, with which kinesis refreshing is prohibited
export var fetchLogger = function fetchLogger(quizSessionId) {
  var kinesisConfigGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getKinesisConfig;
  var logger = loggers[quizSessionId];

  // expires 1 second earlier to protect processing edge case
  if (!logger || logger.needsRefresh(KINESIS_REFRESH_THRESHOLD - 1000)) {
    // send kinesis refreshing request before submission
    loggerHandlers[quizSessionId] = kinesisConfigGetter(quizSessionId);
  }
  return loggerHandlers;
};
export default getLogger;